import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AuthenticationFeatureService } from '../../../features/authentication-feature/authentication-feature.service';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-sign-in',
  standalone: true,
  imports: [MatButtonModule, NgOptimizedImage],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.css',
})
export class SignInComponent implements OnInit {
  constructor(private _authFeature: AuthenticationFeatureService) {}

  ngOnInit() {}

  loginRedirect() {
    this._authFeature.loginRedirect();
  }
}
